const firebaseConfig = {
    apiKey: "AIzaSyDQYtlUtfM03GhHbPfe7oC1L8fkzkBIHTQ",
    authDomain: "doctors-portal-d17bf.firebaseapp.com",
    projectId: "doctors-portal-d17bf",
    storageBucket: "doctors-portal-d17bf.appspot.com",
    messagingSenderId: "366356268417",
    appId: "1:366356268417:web:eb34b38b99f6e60d8a1480"
  };
export default firebaseConfig;